import React from 'react';
import {View} from 'react-native';
import {Components} from '@oneamerica/dxp-ui-components';
import responsiveStyle from './style';
import InfoWrapper from '../../../../components/InfoWrapper/InfoWrapper';
import AdditionalCoverage from './AdditionalCoverage';
const CoverageInformation = ({
  coverageInformationData,
  addCoveragesData = [],
  showcard = true,
}) => {
  const style = responsiveStyle();
  return (
    <View className="lg:flex-row">
      <View className="w-full p-0 mt-8">
        <View style={showcard && style.cardShadow}>
          <View style={style.cardHeader}>
            <Components.Text.H3 style={[style.cardHeaderTitle, style.flex]}>
              Coverage Information
            </Components.Text.H3>
          </View>
          <View className="mt-4" style={style.horizontalDivider} />
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
            className="mt-4 w-full">
            {coverageInformationData.map((data, index) => {
              return (
                <View
                  key={`${data.title}-${index}`}
                  style={{
                    paddingBottom: 20,
                  }}
                  className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/4">
                  <InfoWrapper
                    title={data.title}
                    subTitle
                    information={data.value || '-'}
                    infoTextStyle={{
                      fontWeight: '500',
                    }}
                  />
                </View>
              );
            })}
          </View>
          {addCoveragesData.length > 0 && (
            <AdditionalCoverage addCoveragesData={addCoveragesData} />
          )}
        </View>
      </View>
    </View>
  );
};

export default CoverageInformation;
